import React, { useState, useEffect } from "react";
import SearchField from "./SearchField";

function RadioGroupWithSearch({ apiOptions, defaultOption, setDefaultOption }) {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (apiOptions !== undefined) {
        setOptions(apiOptions);
    }
    // console.log(apiOptions,"apiOptions")
    setSelectedOption(defaultOption);// eslint-disable-next-line 
  }, [apiOptions]);

  // Handle radio button selection
  const handleOptionChange = (option) => {
    setSelectedOption(option);
    // console.log(option.id)
    setDefaultOption(option);
  };

  // Filter options based on search term
  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <SearchField
        onChange={(e) => setSearchTerm(e.target.value)}
        // filter={searchTerm}
      />

      <div
        className="memlist_scroll mt-1 justify-content-center spacing_scroll"
        style={{ height: 300 }}
      >
        {filteredOptions.map((option) => (
          <div
            className={`card mb-2 py-2 px-3`}
            style={{ background: "#F2F4F6" }}
          >
            <label
              key={option.id}
              className="btn-group align-items-center gap-2"
            >
              <p className="affir_checkbox mb-0">
                <input
                  type="radio"
                  name={option.name}
                  value={option.id}
                  checked={selectedOption && selectedOption.id === option.id}
                  onChange={() => handleOptionChange(option)}
                />{" "}
              </p>

              <div
                className="actlist_wid2 ms-2"
                style={{ marginBottom: "-15px" }}
              >
                <p className="py-0"> {option.name}</p>
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RadioGroupWithSearch;
